import { StatusEnum } from './statusEnum'
import { StatusEnumItem } from './StatusEnumItem'

const Draft = new StatusEnumItem({
  description: 'The Lot was created, but not ready to submit',
  id: '385C1EE0-1342-4BAF-A46A-20A0A2774F69',
  name: 'Draft',
  priority: 0,
})

const Closed = new StatusEnumItem({
  description: 'The Lot is submitted and closed',
  id: '043DAE53-07AC-4BCF-A5F5-C44532305E60',
  name: 'Closed',
  priority: 1,
})

export type LIMSAsphaltLotStatusItem = typeof Draft | typeof Closed

class LIMSAsphaltLotStatusEnum extends StatusEnum<
  'LIMSAsphaltLotStatus',
  LIMSAsphaltLotStatusItem,
  LIMSAsphaltLotStatusItem['name'],
  LIMSAsphaltLotStatusItem['id'],
  LIMSAsphaltLotStatusItem['priority']
> {
  readonly Draft = Draft
  readonly Closed = Closed

  typename = 'LIMSAsphaltLotStatus' as const
  get values() {
    return [this.Draft, this.Closed]
  }
}

export const LIMSAsphaltLotStatus = new LIMSAsphaltLotStatusEnum()
